import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import BarcodeIcon from "../../Assets/Svg/barcode";
import { useState } from "react";

const BarcodeButton = (props) => {
  const {
    name,
    isFocusedProduct,
    setIsFocusedProduct,
    isFocusedInventory,
    setIsFocusedInventory,
  } = props;

  const handleFocus = () => {
    if (name == "product") {
      setIsFocusedProduct(true);
    } else if (name == "inventory") {
      setIsFocusedInventory(true);
    }
  };

  const handleBlur = () => {
    if (name == "product") {
      setIsFocusedProduct(false);
    } else if (name == "inventory") {
      setIsFocusedInventory(false);
    }
  };

  return (
    <>
      {name == "product" ? (
        <button
          type="button"
          className="border-0 p-0"
          size="large"
          onFocus={handleFocus}
          style={{ outline: "none" }}
          onBlur={handleBlur}
          {...props}
        >
          <div className={isFocusedProduct ? "text-[#07B553]" : "text-red-500"}>
            <BarcodeIcon width={30} height={30} />
          </div>
        </button>
      ) : (
        <button
          type="button"
          className="border-0 p-0"
          size="large"
          onFocus={handleFocus}
          style={{ outline: "none" }}
          onBlur={handleBlur}
          {...props}
        >
          <div
            className={isFocusedInventory ? "text-[#07B553]" : "text-red-500"}
          >
            <BarcodeIcon width={35} height={35} />
          </div>
        </button>
      )}
    </>
  );
};

export default BarcodeButton;
